<template>
  <div class="dot"></div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.dot {
  display: inline-block;
  margin: 0 18px;
  content: "";
  height: 3px;
  margin-bottom: 4px;
  width: 3px;
  border-radius: 100%;
  background: currentColor;
}
</style>